import React from 'react';
import Tooltip from '../../components/Tooltip';
import { useLanguage } from '../../contexts/LanguageContext';
import { translate } from '../../locales';
import type { TranslationKey } from '../../locales/types';
import './BusinessStatusIndicator.css';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import AccessTimeFilledIcon from '@mui/icons-material/AccessTimeFilled';

interface BusinessStatusIndicatorProps {
  isActive: boolean;
}

const BusinessStatusIndicator: React.FC<BusinessStatusIndicatorProps> = ({ isActive }) => {
  const { language } = useLanguage();
  const t = (key: TranslationKey) => translate(key, language as 'en' | 'ua');
  return (
    <span className="business-status-indicator" style={{ display: 'inline-flex', alignItems: 'center', marginLeft: 12 }}>
  <Tooltip content={isActive ? t('business.status.active') : t('business.status.inactive')} position="top" align="center">
        <span
          className={isActive ? 'status-dot active' : 'status-dot inactive'}
          aria-label={isActive ? 'Active' : 'Inactive'}
        >
          {isActive ? (
            <CheckCircleIcon style={{ color: 'var(--success)', fontSize: 14 }} />
          ) : (
            <AccessTimeFilledIcon style={{ color: 'var(--grey)', fontSize: 14 }} />
          )}
        </span>
      </Tooltip>
    </span>
  );
};

export default BusinessStatusIndicator;
